import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { MarketingLayout } from "@/components/MarketingLayout";

/**
 * Sign-in is handled by WorkOS AuthKit's hosted UI — this route just bounces
 * to it. We use a single auth surface so users never see two competing
 * sign-in forms. Magic-link, Google, and SSO all happen on the WorkOS page.
 *
 * The `/customer/verify?token=...` endpoint and prefill `/welcome?token=...`
 * flow still exist for in-flight legacy magic-link emails and admin-prefilled
 * prospect invites; those don't go through here.
 */
export default function CustomerLogin() {
  const [params] = useSearchParams();

  useEffect(() => {
    const next = params.get("next") ?? "/dashboard";
    window.location.replace(`/api/auth/login?next=${encodeURIComponent(next)}`);
  }, [params]);

  return (
    <MarketingLayout>
      <div className="mx-auto flex w-full max-w-md flex-col items-center gap-3 px-6 py-24 text-center">
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
        <p className="text-sm text-slate-500">Redirecting to sign-in…</p>
      </div>
    </MarketingLayout>
  );
}
